<template>
    <div v-if="isLoaded" v-loading="isLoading" :element-loading-text="$t('dataLoading')">
        <b-row align-h="between" style="text-align: center;border-bottom:1px solid #ddd;">
            <b-col cols="6" class="mb-2" style="display: flex; justify-content: flex-start; height: 40px;">
                <div @click="routeToDashboard(route.params.site_id, year)" style="font-weight: bold; font-size: 1.2em; align-self: center; cursor: pointer">{{selectedSite.name}}</div>
            </b-col>
            <b-col cols="4" sm="4" md="6" lg="6" xl="5">
                <b-row align-h="end">
                    <year-select @onchange="onYearChange" variant="light"/>
                    <site-multi-select
                        :selectedSiteId="selectedSite.id"
                        :givenSites="filteredSites"
                        :allowEmpty="true"
                        variant="light"
                        @oninput="selectSiteId"/>
                </b-row>
            </b-col>
        </b-row>
        <b-row style="justify-content:space-between;" class="mt-2">
            <b-col cols="8">
                <ul class="nav nav-tabs">
                    <li v-for="(tab,tabKey) in tabs" :key="tabKey" class="nav-item p-2" style="cursor: pointer;" :style="tab.isActive ? tab.style.border : ''">
                        <div @click="activate(tabKey)" :class="{'nav-link': true, 'active': tab.isActive}" :style="tab.isActive ? tab.style.tab : ''">{{ tab.name }}  <b-badge pill :style="tab.isActive ? tab.style.badge : ''">{{ tab.tableInfo.items.length }}</b-badge></div>
                    </li>
                </ul>
            </b-col>
            <!--hid add source button-->
            <b-col cols="4" style="float:right;text-align:right;">
                <template v-if="tabs.activeSources.isActive">
                    <b-button v-if="this.$store.state.user.permissions.canAddDatatype" key="addSource" style="background-color:#41B884;" lg="2" class="pb-2" @click="showCreateSourceModal"><img width="20px" height="20px" src="../../assets/icon/addIcon.svg"/> {{ $t('addSource') }}</b-button>
                </template>
             
            </b-col>
            
        </b-row>
        <vue-table
            v-if="tabs.activeSources.isActive"
            :tableName="'active_data_summary'"
            :initialData="this.tabs.activeSources.tableInfo"
            @openEditModal="showEditSourceModal"
            :isEditable="this.$store.state.user.permissions.canAddDatatype"
            class="mt-3"/>
            <!-- @insertItem="insertItem"
            @deleteItemById="deleteItemById" -->
        <vue-table 
            v-else
            :tableName="'inactive_data_summary'"
            :initialData="this.tabs.inactiveSources.tableInfo"
            @openEditModal="showEditSourceModal"
            :isEditable="this.$store.state.user.permissions.canAddDatatype"
            :isDeletable="false"
            class="mt-3"/>
            <!-- @insertItem="insertItem"
            @deleteItemById="deleteItemById" -->
    </div>
    <div v-else></div>
</template>

<script>
import VueTable from '../../components/Table';
import Multiselect from 'vue-multiselect';
import qs from 'qs';
import _ from 'lodash';
import uuid from 'uuid/v4';
import YearSelect from '../../components/YearSelect';
import SiteMultiSelect from '../../components/SiteMultiSelect';

export default {
    components: {SiteMultiSelect, YearSelect, VueTable, Multiselect},
    name: 'data-summary',
    props: {
        selectedTag: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            isLoaded: false,
            isLoading: true,
            filteredSites: this.$store.state.sites, // Workaround for multi-select plugin,
            selectedSite: null,
            currentDataTypes: [],
            selectedItem: {
                isActive: true
            },
            // tableInfo: {
            //     fields: [],
            //     items: []
            // },
            tabs:{
                activeSources:{
                    isActive:true,
                    tableInfo:{fields:[],items:[]},
                    name: this.$t('activeSources'),
                    style:{
                        border:{'border-bottom':'3px solid #41B884'},
                        tab:{'color':'#41B884'},
                        badge:{'background-color':'#41B884'}
                    }
                },
                inactiveSources:{
                    isActive:false,
                    tableInfo:{fields:[],items:[]},
                    name: this.$t('inactiveSources'),
                    style:{
                        border:{'border-bottom':'3px solid #022B49'},
                        tab:{'color':'#022B49'},
                        badge:{'background-color':'#022B49'}
                    }
                }
            }
        };
    },
    methods: {
        activate(key){
            this.activeTab = key;
            _.each(this.tabs, (tab,tabKey)=> {
                this.currentPage = 1;
                tab.isActive = key==tabKey;
            });
        },
        onYearChange(newYear) {
            this.isLoaded = false;
            this.$store.state.year = newYear;
            this.$router.push({
                name: 'site-data-types',
                params: {site_id: this.route.params.site_id},
                query: {year: this.year, tag: this.selectedTag}
            });
            this.init();
        },
        selectSiteId(site) {
            if (!site) {
                this.$router.push({name: 'data-sites'});
            } else {
                this.selectedSite = site;
                this.$store.state.siteId = site ? site.id : null;
                let tags = site.tags;
                // if tags of selected site don't includes previously selected tag, route is changed and fetches new data on the same component
                if (tags.map(tag => tag.key).indexOf(this.selectedTag) === -1) {
                    this.isLoaded = false;
                    this.$router.push({
                        name: 'site-data-types',
                        params: {site_id: site.id},
                        query: {year: this.year}
                    });
                    this.$nextTick(() => {
                        return this.listDataTypes(site.id).then(() => {
                            this.$emit('changetag', site.id);
                            this.isLaoding = false;
                            this.isLoaded = true;
                        });
                    });
                } else {
                    this.isLoaded = false;
                    this.$router.push({
                        name: 'site-data-types',
                        params: {site_id: site.id},
                        query: {year: this.year}
                    });
                    return this.listDataTypes(site.id)
                        .then(this.prepareTableInfo)
                        .then(() => {
                            this.$Progress.finish();
                            this.isLaoding = false;
                            this.isLoaded = true;
                            return true;
                        });
                }
            }
        },
        prepareTableInfo() {
            let tableHeaders = this.collection.meta[this.selectedTag];
            let activeItems = _.filter(this.collection.data[this.selectedTag], item => !_.get(_.get(item, 'cols'), 'isInactive'));
            let inactiveItems = _.filter(this.collection.data[this.selectedTag], item => _.get(_.get(item, 'cols'), 'isInactive'));
            _.each(activeItems, item => {
                this.currentDataTypes.push(item.id);
            });
            this.currentDataTypes = _.uniq(this.currentDataTypes);
            this.tabs.activeSources.tableInfo = {
                fields: this.isbId(this.$store.state.user.customerId) ? _.filter(_.cloneDeep(tableHeaders), o => o.key !== 'cost') : tableHeaders,
                items: _.map(activeItems, item => {
                    item.path = `/data/${this.route.params.site_id}/types/${item.id}?${qs.stringify(
                        {
                            year: this.year,
                            locale: this.$store.state.locale
                        }
                    )}`;
                    return item;
                })
            };
            this.tabs.inactiveSources.tableInfo = {
                fields: this.isbId(this.$store.state.user.customerId) ? _.filter(_.cloneDeep(tableHeaders), o => o.key !== 'cost') : tableHeaders,
                items: _.map(inactiveItems, item => {
                    item.path = `/data/${this.route.params.site_id}/types/${item.id}?${qs.stringify(
                        {
                            year: this.year,
                            locale: this.$store.state.locale
                        }
                    )}`;
                    return item;
                })
            };
            //duplicates excluded filtered data types array.
            //let filteredDataTypes = _.differenceWith(this.$store.state.dataTypes, items, (dataVal, itemVal) => dataVal.id === itemVal.id);
            return Promise.resolve();
        },

        listDataTypes(siteId) {
            let site = siteId || this.route.params.site_id;
            this.$Progress.start();
            return this.axios
                .get(
                    `/data/${site}/summary?${qs.stringify({
                        year: this.year
                    })}`
                )
                .then(({data}) => {
                    this.$emit('changetag', site);
                    this.collection = data;
                    _.each(Object.keys(this.collection.data), dataGroupKey=>{
                        this.collection.data[dataGroupKey] = _.sortBy(_.get(this.collection.data, dataGroupKey), o=>{
                            return _.toLower(this.$t(_.get(_.get(_.get(o, 'cols'), 'dataType'), 'value')))
                        });
                    });
                    this.isLoaded = true;
                    this.$Progress.finish();
                    return data;
                });
        },
        insertItem(item, callback, onWarnCallBack) {
            let insertedItem = {
                siteId: this.route.params.site_id,
                typeId: null
            };
            this.tabs.activeSources.tableInfo.fields.forEach(field => {
                if (field.key == 'dataType') {
                    insertedItem.typeId = item[field.key].id;
                }
            });
            if (insertedItem.typeId) {
                return this.axios
                    .post(
                        `/data/${this.route.params.site_id}/types/${this.route.query.year}`,
                        insertedItem
                    )
                    .then(data => {
                        this.init();
                        this.$router.go();
                        return callback(data);
                    })
                    .catch(() => {
                        this.$toasted.error(this.$t('duplicateDataType'));
                        return onWarnCallBack();
                    });
            }
        },
        deleteItemById(id) {
            //this.showErrorNotification(this.$t('confirmDataTypeDeletion'))
            return this.axios
                .delete(`/data/${this.route.params.site_id}/types/${id}/${this.route.query.year}`)
                .then(() => {
                    var index = this.currentDataTypes.indexOf(id);
                    this.currentDataTypes.splice(index, 1);
                    this.$toasted.show(this.$t('confirmDataTypeDeletion'), {duration: 5000});
                    setTimeout(() => this.$router.go(), 5000);
                })
                .catch(() => {
                    this.showErrorNotification('Silme işlemi gerçekleştirilemedi, tekrar deneyin.');
                });
        },
        deleteSource(id, isActive) {
            if(isActive) {
                this.tabs.activeSources.tableInfo.items = _.filter(this.tabs.activeSources.tableInfo.items, o=> o.id != id);
            }
            else {
                this.tabs.inactiveSources.tableInfo.items = _.filter(this.tabs.inactiveSources.tableInfo.items, o=> o.id != id);
            }
        },
        setSelectedSource(itemData) {
            let isActive = (itemData.name == 'active sources' || itemData.name == 'active_data_summary');

            if(isActive){
                this.selectedItem = _.find(this.tabs.activeSources.tableInfo.items, o=> o.id == itemData.id);
            }
            else{
                this.selectedItem = _.find(this.tabs.inactiveSources.tableInfo.items, o=> o.id == itemData.id);
            }
            this.selectedItem.isActive = isActive;
        },
        showCreateSourceModal(target) {
            this.$store.commit('SET_MODAL', {
                    eventId: uuid(),
                    type: 'createSource',
                    payload: {
                        page: 'sourceSummary',
                        title: "createSource",
                        selectedSource: {},
                    }   
                });
            this.$nextTick(() => {
                this.$root.$emit('bv::show::modal', 'createSource', target);
                this.$eventHub.$once(this.$store.state.modal.eventId, result => {
                    if (result.emitter == 'insert') {
                        this.init();
                    }
                });
            });
        },
        showEditSourceModal(itemData, event) {
            this.setSelectedSource(itemData);

            this.$store.commit('SET_MODAL', {
                    eventId: uuid(),
                    type: 'updateSource',
                    payload: {
                        page: 'sourceSummary',
                        title: "updateSource",
                        selectedSource: {},
                        selectedItem: this.selectedItem
                    }
                });
            this.$nextTick(() => {
                this.$root.$emit('bv::show::modal', 'createSource', event.target);
                this.$eventHub.$once(this.$store.state.modal.eventId, result => {
                    if (result.emitter === 'update') {
                        this.init();
                    } else if(result.emitter == 'delete') {
                        this.deleteSource(result.data.id, result.data.isActive);
                    }
                });
            });
        },
        init() {
            this.isLoading = true;
            return this.listDataTypes(Number(this.route.params.site_id))
                .then(this.prepareTableInfo)
                .then(() => {
                    this.$Progress.finish();
                    this.isLoading = false;
                    this.isLoaded = true;
                    return true;
                });
        }
    },
    watch: {
        selectedTag() {
            this.prepareTableInfo();
        }
    },
    created() {
        this.selectedSite = _.find(this.sites, {id: Number(this.route.params.site_id)});
        if (this.selectedSite && this.selectedSite.tags.length) {
            this.selectedSite.tags.forEach(tag => {
                tag.key == this.route.query.tag ? (tag.active = true) : (tag.active = false);
            });
        }
        this.$store.state.year = this.route.query.year
            ? Number(this.route.query.year)
            : this.$store.state.year;
        this.$store.state.siteId = this.route.params.site_id ? this.route.params.site_id : null;
        return this.listDataTypes(Number(this.route.params.site_id))
            .then(this.prepareTableInfo)
            .then(() => {
                this.$Progress.finish();
                this.isLoading = false;
                this.isLoaded = true;
                return true;
            });
    }
};
</script>

<style scoped lang="scss">
#tabs .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
    border: none;
    background-color: transparent;
    border-color: transparent transparent #f3f3f3;
    font-size: 16px;
    font-weight: bold;
}
.nav-tabs{
    color: #A7A7A7;
    border-bottom: none !important;
}
.nav-tabs:hover, .nav-link:hover {
    border: none;
}
.circle-icon {
    background: #777879;
    border-radius: 50%;
    text-align: center;
    vertical-align: middle;
    height: auto;
    width: auto;
    padding: 10px;
}
/deep/ .multiselect__tags {
    padding: 12px 30px 0 8px;
    background: #fff!important;
    border: 1px solid #495057 !important;
    input::placeholder {
        color: #000 !important;
    }
    .multiselect__single,
    .multiselect__input {
        font-size: 1em;
        color: #000 !important;
        background: #fff !important;
    }
}
/deep/ .multiselect__option {
    span {
        font-size: 0.9em;
        color: #000 !important;
    }
}
.multiselect__select:before {
    border-color: white transparent transparent !important;
}

.multiselect--active {
    z-index: 3 !important;
}

</style>

<i18n src="../../i18n/common.json"></i18n>
<i18n>
    {
        "tr": {
            "activeSources": "Aktif Kaynaklar",
            "inactiveSources": "Pasif Kaynaklar",
            "addSource": "Kaynak Ekle",
            "dataLoading": "Veri Yükleniyor..."
        },
        "en": {
            "activeSources": "Active Sources",
            "inactiveSources": "Inactive Sources",
            "addSource": "Add Source",
            "dataLoading": "Loading Data..."
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Data/Summary.vue